/**
 * Created by renlaydel on 07/11/2017.
 */
import uniq from 'lodash/uniq';
import {
  addToObject,
  objectToArray,
} from '../../../common/validations/validations_helper';
import { capitalize } from '../../../constants/constant_preference_types';

export const allowedEmptySettings = [
  'auto_print_receipt',
  'available_storage_threshold',
  'background_sync_delay',
  'complete_paid_sale',
  'default_return_to_shelf',
  'disable_lock_register_on_incorrect_pin',
  'display_only_receipt_options_complete_paid_sale',
  'email_from',
  'enable_printing_options',
  'group_price_reason_code',
  'login_popup_reminder_register',
  'netsuite_integration',
  'oms_packing_slip',
  'oms_picking_list',
  'oms_pickup_label',
  'oms_pickup_store_label',
  'oms_shipping_label',
  'on_checkout_tab',
  'payment_types_font_size',
  'pos_hotkey_template',
  'print_template_creditnote',
  'print_template_giftcertificate',
  'print_template_sale_oms',
  'proceed_to_pay_tab',
  'shipping_integrator',
  'shortcuts_pos',
  'shortcuts',
  'tax_line_round',
  'validated_reason_code_required',
  'custom_descriptor_item_cart',
  'custom_descriptor_item_search',
];

export const validate = fields => {
  let error = { _error: [] };

  if (!fields.pref_type) {
    addToObject(error, 'pref_type', 'Preference is a required field');
  }

  if (!fields.type_id) {
    addToObject(
      error,
      'type_id',
      `${capitalize(fields.pref_type)} is a required field`,
    );
  }

  if (fields.pref_type === 'account') {
    fields.list.forEach(item => {
      if (!item.account && !allowedEmptySettings.includes(item.setting)) {
        addToObject(error, item.label, `${item.label} is a required field`);
      }
    });
  }

  let errors = objectToArray(error);
  let _error = [];
  errors = uniq(errors);
  errors.forEach(error => {
    _error.push({ message: error });
  });

  return { ...error, _error };
};
